import { FC } from 'react';

import PurchaseVouchersForm from '@/components/layout/purchaseVouchersPage/PurchaseVouchersForm';

export const PurchaseVouchersPage: FC = () => {
  return (
    <div className="w-full max-w-2xl mx-auto md:ml-10 xl:ml-28 mt-8 md:mt-12 rounded-xl flex flex-col md:flex-row gap-4 px-4 items-start">
      <div className="flex-1 w-full">
        <PurchaseVouchersForm />
      </div>
    </div>
  );
};

export default PurchaseVouchersPage;
